import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_VIEWED_INTEREST_FIELDS_BY_CLASS_ID = gql`
  query viewedInterestFields($classId: Int!) {
    getViewedInterestFields(schoolClassID: $classId) {
      id
      interestName
      value
    }
  }
`;
